__turbopack_context__.v({
  "fadeInItems": "FileDropzone-module__bjAPRa__fadeInItems",
  "fileInput": "FileDropzone-module__bjAPRa__fileInput",
  "fileInputAccepting": "FileDropzone-module__bjAPRa__fileInputAccepting",
  "fileInputIcon": "FileDropzone-module__bjAPRa__fileInputIcon",
  "fileInputImage": "FileDropzone-module__bjAPRa__fileInputImage",
  "fileInputRejecting": "FileDropzone-module__bjAPRa__fileInputRejecting",
  "spacing--lg": "FileDropzone-module__bjAPRa__spacing--lg",
  "spacing--md": "FileDropzone-module__bjAPRa__spacing--md",
  "spacing--sm": "FileDropzone-module__bjAPRa__spacing--sm",
  "spacing--xl": "FileDropzone-module__bjAPRa__spacing--xl",
  "spacing--xs": "FileDropzone-module__bjAPRa__spacing--xs",
  "spacing--xxl": "FileDropzone-module__bjAPRa__spacing--xxl",
  "spacing--xxs": "FileDropzone-module__bjAPRa__spacing--xxs",
  "spacing--xxxl": "FileDropzone-module__bjAPRa__spacing--xxxl",
  "spacing--xxxs": "FileDropzone-module__bjAPRa__spacing--xxxs",
});
